import { DATE_SHORT_FORMAT } from '../../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../constants/rentalPortal'
import { APPLICANT_STAGE } from '../../../../RentalPortalApplicant'
import { getListingUnitLabel } from '../../../../RentalPortalListing'
import { formatDate } from '../../../../Table'

function getIsApplicantBoardCardSelected(item) {
  return item.stage === APPLICANT_STAGE.selected
}

function getIsApplicantBoardCardApproved(item) {
  return item.stage === APPLICANT_STAGE.approved
}

function joinApplicantBoardCardMeta(parts) {
  return parts.filter(Boolean).join(RENTAL_PORTAL_FACT_SEPARATOR)
}

function getApplicantBoardCardBaseMeta({
  isListingScoped,
  item,
  locale,
  t,
  timezone,
}) {
  return [
    isListingScoped ? null : getListingUnitLabel({ listing: item, t }),
    item.source ? t(item.source) : null,
    formatDate({
      date: item.received,
      dateFormat: DATE_SHORT_FORMAT,
      locale,
      timezone,
      useTodayFormat: false,
    }),
  ]
}

export function getApplicantBoardCardMeta({
  isListingScoped,
  item,
  locale,
  t,
  timezone,
}) {
  return joinApplicantBoardCardMeta([
    ...getApplicantBoardCardBaseMeta({
      isListingScoped,
      item,
      locale,
      t,
      timezone,
    }),
    getIsApplicantBoardCardSelected(item) && item.awaiting_approval
      ? t('RentalPortal.ListingBoardAwaitingApprovalKey')
      : null,
  ])
}

export function getApplicantBoardCardHandoff({ hasHandoff, item }) {
  if (!hasHandoff || !getIsApplicantBoardCardApproved(item)) {
    return null
  }

  return item.handed_off
    ? {
        text: 'RentalPortal.ApplicantHandedOffBadgeKey',
        textColor: 'var(--color-success)',
      }
    : {
        text: 'RentalPortal.ApplicantHandoffPendingBadgeKey',
        textColor: 'var(--secondary-text-color)',
      }
}

export function getHasApplicantBoardCardHead({ actions, archived, onSelect }) {
  return onSelect || archived || actions.length > 0
}
